var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-bar"},[_c('div',{staticClass:"bar bg-green-400 h-full",style:({ width: _vm.percent + '%' })},[_vm._v("\n     \n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }